import React, { useState } from 'react';
import { FaGooglePlay, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { projects } from '../data/site';

const showAds = Boolean(projects.find((project) => project.href === '/cinemovie')?.ads);

const CineMovie = () => {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  return (
    <div className="min-h-screen bg-gray-900" style={{ fontFamily: "ui-sans-serif, system-ui, sans-serif" }}>
      {/* IM Logo */}

    <a
    href="/"
    className="fixed top-4 left-4 sm:top-6 sm:left-6 md:top-8 md:left-8 lg:top-10 lg:left-24 z-50
             text-2xl sm:text-3xl md:text-4xl font-bold
             bg-gradient-to-r from-red-600 to-orange-500 bg-clip-text text-transparent
             hover:from-purple-500 hover:to-blue-400 transition-all duration-200"
    >
    IM
    </a>

      {/* Hero Section with Modern Layout */}
      <div className="relative min-h-screen">
        {/* Background with overlay */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.7)), url("/cinemovie.png")',
            backgroundAttachment: 'fixed'
          }}
        />

        {/* Content Grid */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Column - Text Content */}
            <div className="pt-20 lg:pt-0">
              <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
                Talk, Discover, and Watch –
                <span className="text-red-500"> All with CineMovie</span>
              </h1>
              <p className="text-xl text-gray-300 mb-8 max-w-2xl">
                Control your movie experience with voice commands. Browse, search, and discover movies hands-free with our innovative app.
              </p>
              <a
                href="https://play.google.com/store/apps/details?id=com.imranmelikov.cinemovie"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-8 py-4 bg-red-600 text-white font-medium rounded-lg hover:bg-red-700 transition-all duration-300 transform hover:scale-105 w-fit shadow-lg hover:shadow-red-500/30"
              >
                <FaGooglePlay className="mr-2 text-xl" />
                Download on Play Store
              </a>
            </div>

            {/* Right Column - Feature Cards */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 relative">
                  <div className="bg-gray-800/50 backdrop-blur-sm p-6 rounded-2xl transform hover:scale-105 transition-transform duration-300">
                    <h3 className="text-xl font-semibold text-white mb-3">Voice Control</h3>
                    <p className="text-gray-300">Navigate through movies using just your voice commands</p>
                  </div>
                  <div className="bg-gray-800/50 backdrop-blur-sm p-6 rounded-2xl transform hover:scale-105 transition-transform duration-300 lg:mt-12">
                    <h3 className="text-xl font-semibold text-white mb-3">Smart Search</h3>
                    <p className="text-gray-300">Find movies instantly with intelligent search features</p>
                  </div>
                  <div className="bg-gray-800/50 backdrop-blur-sm p-6 rounded-2xl transform hover:scale-105 transition-transform duration-300">
                    <h3 className="text-xl font-semibold text-white mb-3">Personalized</h3>
                    <p className="text-gray-300">Get recommendations based on your preferences</p>
                  </div>
                  <div className="bg-gray-800/50 backdrop-blur-sm p-6 rounded-2xl transform hover:scale-105 transition-transform duration-300 lg:mt-12">
                    <h3 className="text-xl font-semibold text-white mb-3">Smart Library</h3>
                    <p className="text-gray-300">Manage your favorites, plan your watchlist, and revisit your watched titles anytime</p>
                  </div>
                </div>
          </div>
        </div>

        {/* Privacy Policy Section with Modern Styling */}
        <div id="privacy" className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="bg-gray-800/90 backdrop-blur-sm rounded-2xl p-8 shadow-xl">
            <div
              className="flex items-center justify-between cursor-pointer"
              onClick={() => setShowPrivacy(!showPrivacy)}
            >
              <h2 className="text-2xl font-bold text-white">Privacy Policy</h2>
              {showPrivacy ? (
                <FaChevronUp className="text-white text-xl" />
              ) : (
                <FaChevronDown className="text-white text-xl" />
              )}
            </div>

            {showPrivacy && (
              <div className="mt-6 text-gray-300 space-y-6 prose prose-invert max-w-none">
                <p className="text-sm text-gray-400">Last updated: October 7, 2026</p>

                <p>
                  This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.
                </p>

                <h3 className="text-xl font-semibold text-white">Information We Collect</h3>
                <p>When you use CineMovie, we may collect and store the following information through Firebase services:</p>
                <ul className="list-disc pl-6">
                  <li>Name and surname (via Google Sign-In)</li>
                  <li>Email address (via Google Sign-In)</li>
                  <li>Profile photo (optional, chosen from your gallery and stored in Firebase Storage; the app does not ask for broad storage permission)</li>
                  <li>Favorites, watch list, and watched history linked to your account</li>
                  <li>Voice commands, only if you turn that feature on</li>
                </ul>
                <p>
                  We do not store voice recordings. Speech is converted to text on your device by the speech-recognition service so the app can carry out the command.
                </p>
                {showAds ? (
                  <>
                    <p>
                      If you buy Premium, Google Play processes the payment. We do not receive your card number or full payment details. The app stores on your device whether Premium is active, so ads can stay off after you reopen the app.
                    </p>
                    <p>Google AdMob may collect and use:</p>
                    <ul className="list-disc pl-6">
                      <li>Advertising ID</li>
                      <li>IP address</li>
                      <li>Device information, such as model, operating system, and language</li>
                      <li>Ad interactions, such as whether an ad was shown</li>
                    </ul>
                  </>
                ) : null}
                <p>We do not sell your personal information.</p>

                <h3 className="text-xl font-semibold text-white">How We Use Your Information</h3>
                <p>We use the collected information for the following purposes:</p>
                <ul className="list-disc pl-6">
                  <li>To allow authentication and personalized access through Google Sign-In</li>
                  <li>To display your name and profile picture within the app</li>
                  <li>To save and show your favorites, watch list, and watched list</li>
                  <li>To support voice commands when you enable them</li>
                  <li>To load movie, series, and cast information from TMDB and trailers from YouTube</li>
                  {showAds ? <li>To show banner ads and measure them, and to hide those ads if you have Premium</li> : null}
                  {showAds ? <li>To remember your Premium purchase on your device</li> : null}
                </ul>

                {showAds ? (
                  <>
                    <h3 className="text-xl font-semibold text-white">Ads and Premium</h3>
                    <p>
                      CineMovie shows banner ads through Google AdMob. Ads are not shown on the sign-in screen or while a video is playing. If you purchase Premium, banner ads are removed.
                    </p>
                    <p>
                      Premium is a one-time in-app purchase handled by Google Play. It removes ads. It does not sell any other feature. Refunds are handled by Google Play.
                    </p>
                    <p>
                      AdMob may use the Advertising ID to show and measure ads. You can reset or delete the Advertising ID in your device settings. Where the law requires a choice before personalized ads, we will ask for that choice before those ads are used.
                    </p>
                  </>
                ) : null}

                <h3 className="text-xl font-semibold text-white">Sharing Lists</h3>
                <p>
                  You can share a favorites, watch list, or history list as plain text. That text is sent only to the app you pick, such as a messaging app. We do not upload the shared text to our servers.
                </p>

                <h3 className="text-xl font-semibold text-white">Delete Your Personal Data</h3>
                <p>
                  You have the right to delete or request that We assist in deleting the Personal Data that We have collected about You.
                </p>
                <p>
                  You may update, amend, or delete Your information at any time by signing in to Your Account and visiting the account settings section. You may also contact Us to request access to, correct, or delete any personal information that You have provided to Us.
                </p>
                <p>
                  To delete your account and the data stored for it in Firebase: open CineMovie, go to Profile, and select Delete Account. This removes your profile, profile photo, favorites, watch list, and watched history from our Firebase services.
                  {showAds ? " It does not cancel a Google Play purchase. Purchases and refunds are managed in Google Play." : null}
                </p>
                {showAds ? (
                  <p>
                    A Premium flag stored only on your device is removed if you clear the app’s data or uninstall the app.
                  </p>
                ) : null}

                <h3 className="text-xl font-semibold text-white">Third-party Services</h3>
                <p>We use the following third-party services, which may collect information used to identify you:</p>
                <ul className="list-disc pl-6">
                  <li>
                    Firebase Authentication, Cloud Firestore, and Firebase Storage (
                    <a href="https://policies.google.com/privacy" className="text-primary hover:text-primary/80">Google Privacy Policy</a>)
                  </li>
                  {showAds ? (
                    <li>
                      Google Play Billing, for Premium purchases (
                      <a href="https://play.google.com/about/play-terms/" className="text-primary hover:text-primary/80">Google Play Terms of Service</a>)
                    </li>
                  ) : null}
                  {showAds ? (
                    <li>
                      Google AdMob (
                      <a href="https://policies.google.com/privacy" className="text-primary hover:text-primary/80">Google Privacy Policy</a>
                      {" "}and{" "}
                      <a href="https://policies.google.com/technologies/partner-sites" className="text-primary hover:text-primary/80">How Google uses information from sites or apps that use its services</a>)
                    </li>
                  ) : null}
                  <li>
                    TMDB API, for movie, series, and people data (
                    <a href="https://www.themoviedb.org/documentation/api/terms-of-use" className="text-primary hover:text-primary/80">TMDB Terms of Use</a>
                    {" "}and{" "}
                    <a href="https://www.themoviedb.org/privacy-policy" className="text-primary hover:text-primary/80">TMDB Privacy Policy</a>)
                  </li>
                  <li>
                    YouTube API, for trailers (
                    <a href="https://www.youtube.com/t/terms" className="text-primary hover:text-primary/80">YouTube Terms of Service</a>)
                  </li>
                  <li>The device speech-recognition service, when voice commands are on</li>
                </ul>
                <p>
                  These providers process data under their own policies. Some of them, including Google, may process data outside your country.
                </p>

                <h3 className="text-xl font-semibold text-white">Data Security</h3>
                <p>
                  We value your trust in providing us your Personal Information, thus we strive to use commercially acceptable means of protecting it. However, no method of transmission over the internet, or method of electronic storage is 100% secure and reliable.
                </p>

                <h3 className="text-xl font-semibold text-white">Children&apos;s Privacy</h3>
                <p>
                  Our Service is not directed to anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13
                  {showAds ? ", and we do not knowingly show interest-based ads to children" : null}
                  . If You are a parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact Us.
                </p>

                <h3 className="text-xl font-semibold text-white">Your Rights</h3>
                <p>Depending on your location, you may have the right to:</p>
                <ul className="list-disc pl-6">
                  <li>Access the personal data we hold about you</li>
                  <li>Request correction or deletion of your personal data</li>
                  <li>Object to or restrict certain processing of your data</li>
                  <li>
                    Withdraw consent where processing is based on consent
                    {showAds ? ", including choices about personalized ads where that choice is available" : null}
                  </li>
                </ul>
                <p>
                  To exercise these rights, please contact us at:{" "}
                  <a href="mailto:imran.melikov84@gmail.com" className="text-primary hover:text-primary/80">
                    imran.melikov84@gmail.com
                  </a>
                </p>

                <h3 className="text-xl font-semibold text-white">How to Delete Your Account</h3>
                <p>
                  To delete your account and related data stored by us: Open the CineMovie app, go to your Profile, and select Delete Account.
                </p>

                <h3 className="text-xl font-semibold text-white">Contact Us</h3>
                <p>
                  If you have any questions or suggestions about our Privacy Policy, contact us at:{" "}
                  <a href="mailto:imran.melikov84@gmail.com" className="text-primary hover:text-primary/80">
                    imran.melikov84@gmail.com
                  </a>
                </p>
              </div>
            )}
          </div>
        </div>

        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
          <div className="bg-gray-800/90 backdrop-blur-sm rounded-2xl p-8 shadow-xl">
            <div
              className="flex items-center justify-between cursor-pointer"
              onClick={() => setShowTerms(!showTerms)}
            >
              <h2 className="text-2xl font-bold text-white">Terms of Use</h2>
              {showTerms ? (
                <FaChevronUp className="text-white text-xl" />
              ) : (
                <FaChevronDown className="text-white text-xl" />
              )}
            </div>

            {showTerms && (
              <div className="mt-6 text-gray-300 space-y-6 prose prose-invert max-w-none">
                <p className="text-sm text-gray-400">Last updated: October 7, 2026</p>

                <p>
                  These Terms of Use govern your use of the CineMovie mobile application. By downloading, accessing, or using CineMovie, you agree to these Terms and to the{" "}
                  <button
                    type="button"
                    className="inline border-0 bg-transparent p-0 text-primary hover:text-primary/80 cursor-pointer"
                    onClick={() => {
                      setShowPrivacy(true);
                      document.getElementById("privacy")?.scrollIntoView({ behavior: "smooth", block: "start" });
                    }}
                  >
                    Privacy Policy
                  </button>
                  . If you do not agree, do not use the app.
                </p>

                <h3 className="text-xl font-semibold text-white">The Service</h3>
                <p>
                  CineMovie lets you browse movies, series, and people, watch trailers, save favorites, keep a watch list and a watched list, and control parts of the app with voice commands.
                </p>
                <p>
                  Film, series, and cast information is provided through the TMDB API. This product uses the TMDB API but is not endorsed or certified by TMDB. Trailers are provided through the YouTube API. By using trailer features, you also agree to the YouTube Terms of Service at{" "}
                  <a href="https://www.youtube.com/t/terms" className="text-primary hover:text-primary/80">https://www.youtube.com/t/terms</a>.
                </p>
                <p>
                  We do not guarantee that titles, images, trailers, or other third-party content will always be available, complete, or accurate.
                </p>

                <h3 className="text-xl font-semibold text-white">Accounts</h3>
                <p>
                  You sign in with your Google account. You are responsible for activity under that account. You must provide accurate account information and keep access to your Google account secure.
                </p>
                <p>
                  You must be at least 13 years old to use CineMovie. The app is not directed to children under 13.
                </p>

                <h3 className="text-xl font-semibold text-white">Your Content</h3>
                <p>
                  You may save favorites, a watch list, and a watched list, and you may add a profile photo. You keep ownership of that content. You give us permission to store and display it so the app can provide those features.
                </p>
                <p>
                  You can share a list as plain text through another app you choose. That other app receives the text under its own terms. We are not responsible for what you share or for that app.
                </p>
                <p>
                  Do not use CineMovie to break the law, interfere with the service, attempt to access another person’s account, or misuse the TMDB, YouTube, Google, or Firebase services.
                </p>

                <h3 className="text-xl font-semibold text-white">Voice Commands</h3>
                <p>
                  Voice commands are optional. They require microphone permission. Speech is converted to text so the app can run the command. We do not store voice recordings.
                </p>

                {showAds ? (
                  <>
                    <h3 className="text-xl font-semibold text-white">Ads</h3>
                    <p>
                      CineMovie shows banner ads through Google AdMob. Ads are not shown on the sign-in screen or while a video is playing. AdMob’s own terms and privacy policy also apply.
                    </p>

                    <h3 className="text-xl font-semibold text-white">Premium</h3>
                    <p>
                      Premium is a one-time in-app purchase through Google Play. It removes banner ads. It does not unlock any other feature.
                    </p>
                    <p>
                      Google Play processes the payment. We do not receive your card number. The price, taxes, and payment method are shown by Google Play before you confirm the purchase. Refunds are handled by Google Play under Google’s refund rules. Deleting your CineMovie account or uninstalling the app does not by itself refund a purchase.
                    </p>
                    <p>
                      If a purchase is refunded or canceled, Premium is removed and ads return.
                    </p>
                  </>
                ) : null}

                <h3 className="text-xl font-semibold text-white">Account Deletion</h3>
                <p>
                  You may delete your account in the app: open CineMovie, go to Profile, and select Delete Account. This removes the profile, profile photo, favorites, watch list, and watched history that we store for that account in Firebase.
                  {showAds ? " It does not cancel a Google Play purchase." : null}
                </p>

                <h3 className="text-xl font-semibold text-white">Intellectual Property</h3>
                <p>
                  CineMovie, its name, and its original interface are owned by Imran Melikov. Movie, series, image, and video content belong to their respective owners and are shown through TMDB and YouTube. You may not copy, resell, or scrape the service or its content except as these Terms and the third-party terms allow.
                </p>

                <h3 className="text-xl font-semibold text-white">Third-Party Services</h3>
                <p>
                  The app relies on Google Sign-In, Firebase, {showAds ? "Google Play, Google AdMob, " : null}TMDB, and YouTube. Those services may change, stop, or suspend access. We are not responsible for third-party services or for content they supply.
                </p>

                <h3 className="text-xl font-semibold text-white">Disclaimer and Liability</h3>
                <p>
                  CineMovie is provided “as is” and “as available.” We do not warrant that the app will be uninterrupted, error-free, or fit for a particular purpose.
                </p>
                <p>
                  To the extent permitted by law, we are not liable for indirect, incidental, or consequential damages, or for loss of data, profits, or content, arising from your use of the app. Nothing in these Terms limits liability that cannot legally be limited, including liability for fraud or for death or personal injury caused by negligence.
                </p>

                <h3 className="text-xl font-semibold text-white">Changes</h3>
                <p>
                  We may update these Terms. The “Last updated” date will change when we do. If you continue to use CineMovie after an update, you accept the updated Terms. If you do not accept them, stop using the app and delete your account.
                </p>

                <h3 className="text-xl font-semibold text-white">Contact</h3>
                <p>
                  Questions about these Terms:{" "}
                  <a href="mailto:imran.melikov84@gmail.com" className="text-primary hover:text-primary/80">
                    imran.melikov84@gmail.com
                  </a>
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CineMovie;